/**
=========================================================
* Material Dashboard 3 PRO React - v2.4.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2024 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Grid from "@mui/material/Grid";
import Autocomplete from "@mui/material/Autocomplete";
import Chip from "@mui/material/Chip";
import { useState, useMemo, useEffect } from "react";
import axios from "axios";

// Material Dashboard 3 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDAvatar from "components/MDAvatar";

import { API_ESA_OFFICE, API_ESA_OFFICE_UPLOAD } from "utils";

// NewProduct page components
import FormField from "layouts/ecommerce/products/new-product/components/FormField";

// Contoh data penerima, nanti bisa diambil dari API
// const penerimaOptions = [
//   {
//     label: "Budi Santoso",
//     value: "uid1",
//     avatar: "https://randomuser.me/api/portraits/men/32.jpg",
//   },
//   {
//     label: "Siti Aminah",
//     value: "uid2",
//     avatar: "https://randomuser.me/api/portraits/women/44.jpg",
//   },
//   {
//     label: "Joko Widodo",
//     value: "uid3",
//     avatar: "https://randomuser.me/api/portraits/men/45.jpg",
//   },
// ];

// State untuk opsi penerima
const defaultOptions = [];

function Penerima({ values = {}, onChange }) {
  const [penerimaOptions, setPenerimaOptions] = useState(defaultOptions);
  const [statusUser, setStatusUser] = useState(null);
  useEffect(() => {
    // Ambil dinas_id dari localStorage
    let dinas_id = null;
    let user_id = null;
    let status = null;
    try {
      const user = localStorage.getItem("user");
      if (user) {
        const parsed = JSON.parse(user);
        dinas_id = parsed.dinas_id;
        user_id = parsed.uid;
        status = parsed.status;
        console.log(`status: ${status}`);
        console.log(`dinas_id: ${dinas_id}`);
        console.log(`user_id: ${user_id}`);
      }
    } catch (e) {}
    if (!dinas_id || !status) return;
    axios
      .get(
        status === "pimpinan"
          ? `${API_ESA_OFFICE}users/pimpinan/list`
          : `${API_ESA_OFFICE}users/dinas/${dinas_id}`
      )
      .then((res) => {
        if (status === "pimpinan") {
          const options = (res.data || [])
            .filter((data) => data.user_id !== user_id)
            .map((data) => ({
              label: data.nama ? data.nama : "-",
              value: data.user_id,
              avatar: data.uid_RSS
                ? `https://smartdh.rotendaokab.go.id/uploads/${data.uid_RSS}.jpg`
                : undefined,
            }));

          setPenerimaOptions(options);
        } else {
          const options = (res.data || [])
            .filter((data) => data.user_id !== user_id)
            .map((data) => ({
              label: data.nama ? data.nama : "-",
              value: data.user_id,
              avatar: data.uid_RSS
                ? `https://smartdh.rotendaokab.go.id/uploads/${data.uid_RSS}.jpg`
                : undefined,
            }));
          setPenerimaOptions(options);
        }
      })
      .catch((err) => {
        setPenerimaOptions([]);
      });
  }, []);

  // Opsi gabungan dengan 'Pilih Semua'
  const allOptions = [
    { label: "Pilih Semua", value: "all", avatar: "" },
    ...penerimaOptions,
  ];

  const handleChange = (event, value) => {
    const isSelectAll = value.some((v) => v.value === "all");
    const selected = values.penerima || [];
    if (typeof onChange === "function") {
      if (isSelectAll) {
        if (selected.length === penerimaOptions.length) {
          onChange({ penerima: [] });
        } else {
          onChange({ penerima: penerimaOptions });
        }
      } else {
        onChange({ penerima: value });
      }
    }
  };

  return (
    <MDBox>
      <MDTypography variant="h5">Penerima</MDTypography>
      <MDBox mt={1}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <MDBox my={2} display="inline-block">
              <MDTypography
                component="label"
                variant="button"
                fontWeight="regular"
                color="text"
              >
                Tags
              </MDTypography>
            </MDBox>
            <Autocomplete
              multiple
              options={allOptions}
              value={values.penerima || []}
              onChange={handleChange}
              getOptionLabel={(option) => option.label}
              renderOption={(props, option) => (
                <li
                  {...props}
                  style={{ display: "flex", alignItems: "center" }}
                >
                  {option.value === "all" ? (
                    <strong style={{ color: "#1976d2" }}>Pilih Semua</strong>
                  ) : (
                    <>
                      <MDAvatar
                        src={option.avatar}
                        alt={option.label}
                        size="xs"
                        sx={{ mr: 1 }}
                      />
                      {option.label}
                    </>
                  )}
                </li>
              )}
              renderTags={(selected, getTagProps) =>
                selected.map((option, index) => (
                  <Chip
                    {...getTagProps({ index })}
                    key={option.value}
                    avatar={
                      <span style={{ display: "flex", alignItems: "center" }}>
                        <MDAvatar
                          src={option.avatar}
                          alt={option.label}
                          size="xxs"
                          sx={{ width: 24, height: 24, mr: 1 }}
                        />
                        <span style={{ marginLeft: 4 }} />
                      </span>
                    }
                    label={option.label}
                    style={{
                      marginRight: 4,
                      marginBottom: 2,
                      display: "flex",
                      alignItems: "center",
                    }}
                  />
                ))
              }
              renderInput={(params) => (
                <MDInput
                  {...params}
                  variant="standard"
                  label="Penerima Instruksi"
                />
              )}
            />
          </Grid>
        </Grid>
      </MDBox>
    </MDBox>
  );
}

export default Penerima;
